var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHouseholdBills = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Accounting-Document--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Accounting Document Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.56 5.85 16.15 0.44A1.52 1.52 0 0 0 15.09 0H3.5A1.5 1.5 0 0 0 2 1.5v21A1.5 1.5 0 0 0 3.5 24h18a0.5 0.5 0 0 0 0.5 -0.5V6.91a1.52 1.52 0 0 0 -0.44 -1.06ZM9.82 11.18 6.45 9.92A2.54 2.54 0 0 1 5 7.45a2.53 2.53 0 0 1 2.29 -2.53 0.25 0.25 0 0 0 0.21 -0.25V4a1 1 0 0 1 2 0v0.63a0.25 0.25 0 0 0 0.25 0.25H11a1 1 0 0 1 0 2H7.88c-0.88 0 -0.88 0.43 -0.88 0.57a0.93 0.93 0 0 0 0.18 0.62l3.37 1.26A2.54 2.54 0 0 1 12 11.8a2.53 2.53 0 0 1 -2.29 2.53 0.25 0.25 0 0 0 -0.21 0.25v0.67a1 1 0 0 1 -2 0v-0.62a0.25 0.25 0 0 0 -0.25 -0.25H6a1 1 0 0 1 0 -2h3.12c0.88 0 0.88 -0.44 0.88 -0.58a0.93 0.93 0 0 0 -0.18 -0.62Zm8.68 3.57a0.75 0.75 0 0 1 0 1.5h-5a0.75 0.75 0 0 1 0 -1.5ZM14.75 11a0.76 0.76 0 0 1 0.75 -0.75h3a0.75 0.75 0 0 1 0 1.5h-3a0.76 0.76 0 0 1 -0.75 -0.75Zm3.75 8.25a0.75 0.75 0 0 1 0 1.5h-10a0.75 0.75 0 0 1 0 -1.5Z",
    fill: "currentColor",
    strokeWidth: 1
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHouseholdBills);
export default ForwardRef;